export default {
    namespaced: true,
    state: {
        // 开启功能
        cmpt: null,
        // 绑定的input
        sel: null,
        // 产品编号
        productNo: null,
        // 偏移量Top
        top: null,
        // 偏移量Left
        left: null,
        // 偏移量Right
        right: null,
        // 语言
        lang: null,
        // 动态跟随开关
        follow: null,
        // 点击结果回调事件
        callback: null,
        // 输入框回车回调事件
        enterCallback: null,
        // 插件层级
        zIndex: null,
        // input清空错误数据 默认开启
        cleanInput: null,
        // 插件输入框数据
        inputData: null,
        // input对应model对象
        inputModel: null,
        // 隐藏插件
        hideFn: null,
        onlyProduct: '',// 1-只有产品
    },
    mutations: {
        // 切换ref绑定 || 重置数据
        ReloadPlugin(state, {
            cmpt = ['dest', 'airline'],
            top = 0,
            left = null,
            right = null,
            lang = 'cn',
            follow = false,
            callback = () => {
            },
            enterCallback = () => {
            },
            zIndex = 3,
            cleanInput = true,
            inputData = '',
            inputModel = '',
            sel = null,
            onlyProduct = ''
        }) {
            state.cmpt = cmpt;
            state.top = top;
            state.left = left;
            state.right = right;
            state.lang = lang;
            state.follow = follow;
            state.callback = callback;
            state.enterCallback = enterCallback;
            state.zIndex = zIndex;
            state.cleanInput = cleanInput;
            state.inputData = inputData;
            state.inputModel = inputModel;
            state.sel = sel;
            state.onlyProduct = onlyProduct;
        },
        onlyProduct(state,value) {
            state.onlyProduct = value;
        },
        // 切换产品编号
        productNo(state, value) {
            state.productNo = value;
        },
        // 对input赋值
        inputData(state, value) {
            state.inputData = value;
        },
        // 隐藏插件
        hideFn(state, value) {
            state.hideFn = value;
        }
    }
};